import React, { useEffect, useMemo, useState } from "react";
import { motion } from "framer-motion";

const pad = (n) => String(n).padStart(2, "0");

export const CountdownGate = ({
  target,         // Date | number (ms). Ej: Date.now() + 20*60*1000
  title = "La ceremonia de premiación comienza en",
  onEnd,          // callback cuando llega a 0
  onTick,         // opcional: (secondsLeft) => void
}) => {
  const targetMs = useMemo(
    () => (target instanceof Date ? target.getTime() : Number(target)),
    [target]
  );

  const calcLeft = () => Math.max(0, Math.floor((targetMs - Date.now()) / 1000));
  const [left, setLeft] = useState(calcLeft());

  useEffect(() => {
    setLeft(calcLeft());
    const iv = setInterval(() => {
      setLeft((prev) => {
        const s = Math.max(0, prev - 1);
        onTick?.(s);
        if (s === 0) {
          clearInterval(iv);
          onEnd?.();
        }
        return s;
      });
    }, 1000);
    return () => clearInterval(iv);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [targetMs]);

  const hours = Math.floor(left / 3600);
  const mins  = Math.floor((left % 3600) / 60);
  const secs  = left % 60;

  const label =
    hours > 0
      ? `${pad(hours)}:${pad(mins)}:${pad(secs)}`
      : `${pad(mins)}:${pad(secs)}`;

  return (
    <section className="relative w-full min-h-[calc(100vh-64px)] flex items-center justify-center overflow-hidden bg-gradient-to-b from-black via-gray-900 to-black">
      {/* fondo bandera/huellas suave */}
      <div
        className="absolute inset-0 opacity-[0.08] pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(90deg, rgba(255,255,255,.08) 50%, transparent 50%), linear-gradient(0deg, rgba(255,255,255,.08) 50%, transparent 50%)",
          backgroundSize: "24px 24px, 24px 24px",
          animation: "countFlag 18s linear infinite",
        }}
      />
      <style>{`
        @keyframes countFlag {0%{background-position:0 0}100%{background-position:200px 0}}
        @keyframes shine {0%{transform:translateX(-20%) skewX(-15deg);opacity:0}20%{opacity:.9}100%{transform:translateX(120%) skewX(-15deg);opacity:0}}
      `}</style>

      <div className="relative z-10 text-center px-6">
          <div className="mt-5 text-white/60 mb-4" style={{fontSize:"20px"}}>
          FECHA DE EVENTO: <span className="text-white">{'3/09/2025 09:00 hrs.'}</span>
        </div>
        <p className="text-white/70 tracking-[0.35em] text-xs md:text-sm uppercase mb-3">
          {title}
        </p>

        {/* Dígitos grandes */}
        <motion.div
          key={label}
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ type: "spring", stiffness: 140, damping: 14 }}
          className="font-extrabold leading-none"
          style={{ letterSpacing: "0.06em" }}
        >
          <span className="text-[18vw] md:text-[12vw] bg-clip-text text-transparent bg-gradient-to-b from-white to-gray-400 drop-shadow">
            {label}
          </span>
        </motion.div>

        {/* Barra de progreso */}
        <div className="mx-auto mt-6 w-[80vw] md:w-[560px] h-2 rounded-full bg-gray-800 overflow-hidden">
          <motion.div
            initial={{ width: "100%" }}
            animate={{ width: `${(left / Math.max(left, 1)) * 100}%` }} // mantiene animación al principio
            transition={{ duration: 0.4 }}
            className="h-full bg-gradient-to-r from-red-600 via-red-500 to-red-700"
            style={{ width: `${Math.max(0, (left / Math.max(left, 1)) * 100)}%` }}
          />
        </div>

      
        <div className="mt-5 text-white/60 text-sm">
          Evento Finaliza: <span className="text-white">{new Date(targetMs).toLocaleString()}</span>
        </div>
      </div>

      {/* brillo de pasada */}
      <div className="absolute inset-y-1/3 left-0 right-0 bg-gradient-to-r from-transparent via-white/25 to-transparent opacity-50 animate-[shine_2s_ease-in-out_infinite]" />
    </section>
  );
};
